import PropTypes from 'prop-types';
import InteractiveElement from '../../../atoms/interactive-element';
import styles from './tag.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const buildProfileTagHref = (urlDomain, urlPrefix, tagCharacteristic = '', isMyTiaa) => {
  //remove leading and tailing /
  if (urlPrefix[0] === '/') {
    urlPrefix = urlPrefix.slice(1, urlPrefix.length);
  }
  if (urlPrefix[urlPrefix.length - 1] === '/') {
    urlPrefix = urlPrefix.slice(0, -1);
  }
  let tagHref = `screener.html?channel=public&bluetagcharacteristic=${tagCharacteristic}`;
  if (
    window.location.href.indexOf('localhost') === -1 &&
    urlDomain.indexOf('services.mdgapp') === -1 &&
    urlDomain.indexOf('.markit') === -1
  ) {
    tagHref = `${urlDomain}/${urlPrefix}/investment-performance?bluetagcharacteristic=${tagCharacteristic}`;
    if (isMyTiaa) {
      tagHref = `${urlDomain}/${urlPrefix}/secureperfview/performance?bluetagcharacteristic=${tagCharacteristic}`;
    }
  }
  return tagHref;
};

const onButtonClick = url => {
  window.open(url, '_self');
};

const Tag = ({
  label,
  index,
  popoverMsg,
  lastTagIndex,
  outBoundsTagIndex,
  isMyTiaa,
  isMicrosites,
  isProfilePage,
  children,
  onSvgClick,
  urlDomain,
  urlPrefix
}) => {
  const getBoundariesStyle = () => {
    if (index === 0) return 'move-right';
    if (index === lastTagIndex) return 'move-left';
    if (index === outBoundsTagIndex) return 'move-right';
    return '';
  };

  return children ? (
    <InteractiveElement
      {...className('label', 'profile-svg-label')}
      onClick={onSvgClick}
      data-popover-msg={popoverMsg}
      aria-label={popoverMsg}
      tabIndex={0}
      role="tooltip"
    >
      {children}
    </InteractiveElement>
  ) : (
    <InteractiveElement
      {...className('label', getBoundariesStyle(), isProfilePage && 'profile-label')}
      data-popover-msg={popoverMsg}
      onClick={() =>
        (isMicrosites || isMyTiaa) &&
        onButtonClick(
          buildProfileTagHref(
            urlDomain,
            urlPrefix,
            label.replace(/\s/g, '').toLowerCase(),
            isMyTiaa
          )
        )
      }
      tabIndex={0}
      role={isProfilePage && (isMicrosites || isMyTiaa) ? 'button' : 'tooltip'}
    >
      {label}
    </InteractiveElement>
  );
};

Tag.propTypes = {
  label: PropTypes.string,
  index: PropTypes.number,
  popoverMsg: PropTypes.string,
  lastTagIndex: PropTypes.number,
  outBoundsTagIndex: PropTypes.number,
  isMyTiaa: PropTypes.bool,
  isMicrosites: PropTypes.bool,
  isProfilePage: PropTypes.bool,
  children: PropTypes.element,
  onSvgClick: PropTypes.func,
  urlDomain: PropTypes.string,
  urlPrefix: PropTypes.string
};

export default Tag;
